export const RESTAURANT_TYPE = {
  NOODLES: "noodles",
  MILK_TEA: "milktea",
  CAFE: "cafe",
  GRILL: "grill",
  HOT_POT: "hotpot",
  RICE: "rice",
  FASTFOOD: "fastfood",
  OTHERS: "others",
  BUFFET: "buffet",
  ALL: "all",
};

export const RESTAURANT_TYPE_OPTIONS = [
  {
    label: "Tất cả",
    value: RESTAURANT_TYPE.ALL,
  },
  {
    label: "Bún/miến/phở",
    value: RESTAURANT_TYPE.NOODLES,
  },
  {
    label: "Cơm/cháo",
    value: RESTAURANT_TYPE.RICE,
  },
  {
    label: "Đồ ăn nhanh",
    value: RESTAURANT_TYPE.FASTFOOD,
  },
  {
    label: "Cà phê",
    value: RESTAURANT_TYPE.CAFE,
  },
  {
    label: "Chè/Trà sữa",
    value: RESTAURANT_TYPE.MILK_TEA,
  },
  {
    label: "Lẩu",
    value: RESTAURANT_TYPE.HOT_POT,
  },
  {
    label: "Nướng",
    value: RESTAURANT_TYPE.GRILL,
  },
  {
    label: "Buffet/Nhậu",
    value: RESTAURANT_TYPE.BUFFET,
  },
  {
    label: "Khác",
    value: RESTAURANT_TYPE.OTHERS,
  },
];

export const SORT_BY_AZ = {
  ASCENDING: "asc",
  DESCENDING: "des",
};

export const SORT_BY_PRICE = {
  ASCENDING: "asc",
  DESCENDING: "des",
};

export const SORT_BY_DISTANCE = {
  FURTHEST: "furthest",
  NEAREST: "nearest",
};

export const SORT_TYPE = {
  AZ: "AZ",
  PRICE: "PRICE",
  DISTANCE: "DISTANCE",
};

export const DRINKING_VALUE_LIST = [
  {
    label: "Thoát nạn",
    value: 1,
  },
  {
    label: "Uống 50% + thêm 1 lượt quay",
    value: 2,
  },
  {
    label: "Con trai uống 100%",
    value: 3,
  },
  {
    label: "Tất cả uống 100%",
    value: 4,
  },
  {
    label: "Thoát nạn",
    value: 5,
  },
  {
    label: "Chọn 1 người cùng uống 100%",
    value: 6,
  },
  {
    label: "Bên trái uống 50%",
    value: 7,
  },
  {
    label: "Chỉ định 1 người uống 50%",
    value: 8,
  },
  {
    label: "Tất cả uống 50%",
    value: 9,
  },
  {
    label: "Thoát nạn",
    value: 10,
  },
  {
    label: "Con gái uống 100%",
    value: 11,
  },
  {
    label: "Uống 100% với 2 người ngồi cạnh",
    value: 12,
  },
  {
    label: "Uống 200%",
    value: 13,
  },
  {
    label: "Đối diện uống 50%",
    value: 14,
  },
  {
    label: "Bên phải uống 50%",
    value: 15,
  },
  {
    label: "Tất cả uống 100%",
    value: 16,
  },
];

export const LUCKY_GAME_TAB = {
  DRINKING: "drinkingTab",
};

export const PAGE = {
  RESTAURANT: "restaurantPage",
  LUCKY_GAMES: "luckyGamesPage",
};
